// CORE
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

// MUI

// DATA
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import * as transactionActions from 'data/transactions/actions';
import * as transactionSelectors from 'data/transactions/selectors';

// CUSTOM
import useQDialogs from 'components/QDialogs/useQDialogs';

import * as qdata from './core';


function useQData(wrapperId, robotMode) {

  const txnsByAccountId = useSelector(transactionSelectors.getTransactionsByAccountId);
  const featureFlags = useSelector(getFeatureFlags);
  const productName = featureFlags.get('productName');

  const dispatch = useDispatch();
  const createTransactions = (payload, meta) => dispatch(transactionActions.createTransactions(payload, meta));
  const updateTransactions = (payload, meta) => dispatch(transactionActions.updateTransactions(payload, meta));
  const deleteTransactions = (payload, meta) => dispatch(transactionActions.deleteTransactions(payload, meta));
  const performTransactionAction = (payload, meta) => dispatch(transactionActions.performTransactionAction(payload, meta));
  const genericDispatch = (action) => dispatch(action);

  const { dialogAlert } = useQDialogs();

  const forwardProps = {
    wrapperId,
    robotMode,
    createTransactions,
    deleteTransactions,
    updateTransactions,
    performTransactionAction,
    genericDispatch,
    featureFlags,
    txnsByAccountId,
    productName,
    dialogAlert,
  };

  const QDperformTransactionAction = (action) => qdata.performTransactionAction (action, forwardProps);
  const QDunMatchTransaction = (txn) => qdata.unMatchTransaction(txn, forwardProps);
  const QDmatchTransactions = (txns) => qdata.matchTransactions(txns, forwardProps);
  const QDdeleteTransactions = (txns) => qdata.deleteTransactions(txns, forwardProps);
  const QDsaveTransactions = (txns, cb) => qdata.saveTransactions(txns, cb, forwardProps);
  const QDsetBalanceAdjust = (accountId, date, amount) => qdata.setBalanceAdjust(accountId, date, amount, forwardProps);

  return {
    qDataSaveTransactions: QDsaveTransactions,
    qDataDeleteTransactions: QDdeleteTransactions,
    qDataMatchTransactions: QDmatchTransactions,
    qDataUnMatchTransaction: QDunMatchTransaction,
    qDataPerformTransactionAction: QDperformTransactionAction,
    qDataSetBalanceAdjust: QDsetBalanceAdjust,
  };
}

useQData.propTypes = {
  wrapperId: PropTypes.string,
  robotMode: PropTypes.bool,
};
useQData.defaultProps = {
  robotMode: false,
};

export default useQData;
